import type { User } from "../../types/user";
import { UserMenu } from "./UserMenu";

interface HeaderProps {
  user: User;
}

export function Header({ user }: HeaderProps) {
  return (
    <header className="shrink-0 border-b bg-background">
      <div className="flex h-16 items-center justify-end px-6">
        <UserMenu user={user} />
      </div>
    </header>
  );
}
